module.exports = __webpack_public_path__ + "static/img/img01@2x.f7d4fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img01@2x.png
// module id = P282
// module chunks = 174